// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import CreateSub from "./pages/CreateSub";
import SubDetail from "./pages/SubDetail";
import Navigation from "./components/Navbar";
import Login from "./components/Auth/Login";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import mixpanel from "mixpanel-browser";
 
// Near entry of your product, init Mixpanel
mixpanel.init("182d9c58d8b6789751e93a8425959426", {
  // debug: true,
  track_pageview: true,
  // persistence: "localStorage",
  record_sessions_percent: 100, //records 100% of all sessions
  record_heatmap_data: true,
  autocapture: true,
  api_host: 'https://api-eu.mixpanel.com',
});

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const [showDrawer, setShowDrawer] = useState(false);

  const openDrawer = () => setShowDrawer(true);
  const closeDrawer = () => setShowDrawer(false);

   useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);

          if (currentUser) {
            mixpanel.identify(currentUser.uid);

            mixpanel.people.set({
              $email: currentUser.email,
              $name: currentUser.displayName,
            });

            // ✅ ADD THIS
            mixpanel.people.set_once({
              first_seen: new Date().toISOString(),
              signup_date: new Date().toISOString()
            });
          }
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  return (
    <Router>
      <Navigation openDrawer={openDrawer}/>
      <div className="container mt-2">
        <Routes>
        <Route
          path="/"
          element={
            user ? (
              <Home
                showDrawer={showDrawer}
                closeDrawer={closeDrawer}
              />
            ) : (
              <Login />
            )
          }
        />
          {/* <Route
            path="/"
            element={user ? <Navigate to="/" /> : <Login />}
          /> */}
          <Route path="/" element={<Home />} />
          <Route path="/create" element={<CreateSub />} />
          <Route path="/sub/:id" element={<SubDetail />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;